export default __webpack_public_path__ + "static/media/triangle3.b65eb59c.svg";